<div class="step-three">
    <h2 *ngIf="paymentType == 1">¡Compra Pendiente!</h2>
    <h2 *ngIf="paymentType == 2">¡Compra Pendiente!</h2>

    <img src="/assets/img/successful-purchase.webp" alt="Compra Exitosa" />

    <p *ngIf="paymentType == 1">Tu pedido ha ingresado al proceso de revisión, quedando sujeto a aprobación crediticia. Te enviaremos un mensaje de seguimiento al mail: <span>{{ currentUser.email }}</span></p>
    <p *ngIf="paymentType == 2">Deberas realizar el pago en efectivo, te enviaremos un mensaje de seguimiento al mail: <span>{{ currentUser.email }}</span></p>

    <p>Tu número de compra es: <strong>{{ transactionId }}</strong></p>

    <div class="buttons">
        <button mat-button [routerLink]="['/']">Volver al inicio</button>
        <button mat-button [routerLink]="['/buscar-producto']">Seguir comprando</button>
    </div>
</div>